import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';

@Component({
  selector: 'app-detail-field',
  template: `
    <div class="app-detail-field" [ngClass]="customClass">
      <app-label
        *ngIf="label"
        [text]="label"
        [mandatory]="mandatory"
        [optional]="optional"
        [tooltip]="tooltip"
      ></app-label>
      <div class="app-detail-field__content">
        <p *ngIf="hasValue; else fallbackSlot" class="app-detail-field__value">{{ displayValue }}</p>
        <ng-template #fallbackSlot>
          <ng-content></ng-content>
          <p *ngIf="!hasValue && fallback" class="app-detail-field__value app-detail-field__value--empty">{{ fallback }}</p>
        </ng-template>
      </div>
    </div>
  `,
  styles: [`
    :host {
      display: block;
      width: 100%;
    }

    .app-detail-field {
      display: flex;
      flex-direction: column;
      margin-bottom: 24px;
      box-sizing: border-box;
      width: 100%;

      &__content {
        display: flex;
        align-items: flex-start;
        min-height: 20px;
        width: 100%;
      }

      &__value {
        font-family: 'Gilroy', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif !important;
        font-size: 14px !important;
        font-weight: 700 !important;
        color: #000000 !important;
        line-height: 20px !important;
        margin: 0 !important;
        padding: 0 !important;
        word-break: break-word;

        &--empty {
          color: #000000 !important;
          font-weight: 700 !important;
        }
      }
    }
  `]
})
export class AppDetailFieldComponent implements OnChanges {
  @Input() label: string = '';
  @Input() value: any = undefined;
  @Input() fallback: string = '-';
  @Input() mandatory: boolean = false;
  @Input() optional: boolean = false;
  @Input() tooltip: string = '';
  @Input() customClass: string = '';

  hasValue: boolean = false;
  displayValue: string = '';

  ngOnChanges(changes: SimpleChanges): void {
    this.evaluateValue();
  }

  private evaluateValue(): void {
    if (this.value === undefined || this.value === null) {
      this.hasValue = false;
      this.displayValue = '';
      return;
    }

    const str = String(this.value).trim();
    // Check if empty or just dial code like "+91" or "+"
    if (!str || str === '+' || /^\+\d{1,4}$/.test(str)) {
      this.hasValue = false;
      this.displayValue = '';
      return;
    }

    this.hasValue = true;
    this.displayValue = str;
  }
}
